const config = {
  apiUri: process.env.REACT_APP_API_URI || 'https://adminapi.levelup.no/billing/v1',
  apiToken: process.env.REACT_APP_API_TOKEN || process.env.API_TOKEN || 'no-token'
}

export default config
